import axios from 'axios';
import i18n from '@/locales/i18n';
import store from '@/store/store';
import { LanguageService } from '@/services/storage.service';
import { validateInstallations } from '@/models/installations.model';

const DemoService = {
  async getUserData() {
    const lang = i18n.locale;
    const path = `demo_${lang}.json`;
    const instance = axios.create({ baseURL: 'demo/' });

    const demoData = await instance.get(path);

    const user = demoData.data.user;
    const installations = validateInstallations(demoData.data.installations);

    // Save local data and config language
    LanguageService.saveLanguage(lang);

    // Salvo los datos del usuario y sus instalaciones en el store,
    // quito el loader y redirijo al usuario a la página solicitada inicialmente,
    // o a la página de inicio
    store.dispatch('globalModule/setDemo', true);
    store.dispatch('userModule/saveUser', user);
    store.dispatch('unitsModule/saveInstallations', installations);
  },

  async getUsers(installationID) {
    const lang = i18n.locale;
    const path = `demo_${lang}.json`;
    const instance = axios.create({ baseURL: 'demo/' });

    const demoData = await instance.get(path);
    return demoData.data.users[installationID];
  },
};

export default DemoService;
